import React from "react";
import { Col, Grid, Row, Well } from "react-bootstrap";
import { Button, Input } from "antd";
import $ from "jquery";
import strategyConfigs from "../component/strategy-configs";
import ConfigGetter from "../utils/ConfigGetter";

const { TextArea } = Input;

const cnf = ConfigGetter.getConfig();
const defaultPortfolio = "Portfolio";

/**
 * main component
 */
class PortfolioMonitorConfig extends React.Component {
    constructor (props) {
        // const { handle } = this.props.match.params

        // history: {length: 12, action: "PUSH", location: {…}, createHref: ƒ, push: ƒ, …}
        // location: {pathname: "/portfolio_monitor_config", search: "?p=hft", hash: "", state: undefined}
        // match: {path: "/portfolio_monitor_config", url: "/portfolio_monitor_config", isExact: true, params: {…}}
        // staticContext: undefined
        // this.props.location.search

        // Using component
        // <Route path="/users/:id" component={UserPage}/> 
        // this.props.match.params.id
        // The component is automatically rendered with the route props.

        // Using render
        // <Route path="/users/:id" render={(props) => <UserPage {...props} />}/> 
        // this.props.match.params.id
        // Route props are passed to the render function.

        super(props);
        // const that = this;
        this.state = {
            data: undefined,
            // lastModify: Date.now(),
            config: "",
            portfolio: "Portfolio"
        };
        // this.logout=this.logout.bind(this);
    }

    componentWillMount () {
        let path = window.location.hash;
        let permission = JSON.parse(localStorage.getItem("permission"));
        if (!permission || !(path.substr(1, path.length - 1) in permission)) {
            this.props.history.push("/forbidden");
            return;
        }

        let params = new URLSearchParams(this.props.location.search);
        // console.log('params:', params.toString());

        if (params.has("p") && strategyConfigs.hasOwnProperty(params.get("p"))) {
            this.setState({ portfolio: params.get("p") });
            this.state.portfolio = params.get("p"); // FIXME: why setState not work?
        }

        $.ajax({
            method: "post",
            url: cnf["restUrl"] + "/login",
            data: {
                username: localStorage.getItem("username") || "guest",
                password: localStorage.getItem("password") || sessionStorage.getItem("password") || "pass"
            },
            success: (data) => {
                localStorage.setItem("user", JSON.parse(data)["user"]);
            },
            error: (data) => {
                console.log(data);
                this.props.history.push("/login");
            }
        });
        let that = this;
        $.ajax({
            method: "get",
            url: cnf["restUrl"] + "/strategy_status/getConfig/" + strategyConfigs[that.state.portfolio],
            success: (data) => {
                if (data) {
                    if (typeof (data) === "string") data = JSON.parse(data);
                    that.setState({ data: data, init: data });
                }
            },
            error: (data) => {
                console.log(data);
            }
        });
    }

    componentDidUpdate (preProps, preState) {
        if (preProps.location.search !== this.props.location.search) {
            let params = new URLSearchParams(this.props.location.search);
            if (params.has("p") && strategyConfigs.hasOwnProperty(params.get("p"))) {
                this.setState({ portfolio: params.get("p") });
                this.state.portfolio = params.get("p");
            }
            else {
                this.setState({ portfolio: defaultPortfolio });
                this.state.portfolio = defaultPortfolio;
            }
            this.refresh();
        }
    }

    refresh () {
        let that = this;
        let path = window.location.hash;
        let permission = JSON.parse(localStorage.getItem("permission"));
        if (!permission || !(path.substr(1, path.length - 1) in permission)) {
            this.props.history.push("/forbidden");
            return;
        }

        $.ajax({
            method: "get",
            url: cnf["restUrl"] + "/strategy_status/getConfig/" + strategyConfigs[that.state.portfolio],
            success: (data) => {
                if (data) {
                    if (typeof (data) === "string") data = JSON.parse(data);
                    that.setState({ data: data, init: data });
                }
            },
            error: (data) => {
                console.log(data);
            }
        });
    }

    updateConfig (e) {
        e.preventDefault();
        try {
            if (typeof (JSON.parse(this.state.config)) === "string") {
                alert("invalid JSON format!");
                return null;
            }
            JSON.parse(this.state.config);
        } catch (e) {
            alert("invalid JSON format!");
            return null;
        }
        let that = this;
        $.ajax({
            method: "post",
            url: cnf["restUrl"] + "/strategy_status/setConfig/" + strategyConfigs[this.state.portfolio],
            data: this.state.config,
            contentType: "application/json",
            dataType: "text",
            success: (data) => {
                alert("update config successfully!");
                that.refresh();
            },
            error: (data) => {
                if (data.status > 200) {
                    alert(`error: ${data.statusText}`);
                }

                console.log(data);
            }
        });
    }

    handleConfigChange (e) {
        e.preventDefault();
        this.setState({
            config: e.target.value
        });
    }

    render () {
        return (
            <div>
                <Grid fluid={true}>
                    <Well>
                        <Row>
                            <Col sm={6} md={5}>
                                <h4>Update Monitor Config:</h4>
                                <TextArea showCount allowClear rows={5} onChange={(e) => this.handleConfigChange(e)}/>
                                <br/>
                                <Button onClick={(e) => this.updateConfig(e)}>Update</Button>
                                <br/>
                                <br/>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6} md={12}>
                                <h5>Current Config:</h5>
                                <p style={{ fontSize: "11px" }}>{JSON.stringify(this.state.init, null, 2)}</p>

                            </Col>
                        </Row>
                    </Well>
                </Grid>
            </div>
        );
    }
}

export default PortfolioMonitorConfig;



// WEBPACK FOOTER //
// ./src/view/PortfolioMonitorConfig.js